<template>
	<div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
			<div class="container">
				<div class="breadcrumb-content text-center">
					<h2>展会详情</h2>
				</div>
			</div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
			<div class="container">
				<div class="row">
					<div class="col-lg-9">
						<Carousel loop>
							<CarouselItem v-for="(img,imgindex) in exhibitionInfo.img_detail" :key="imgindex">
								<div><img :src="img | imgfilter" style="width: 100%;"></div>
							</CarouselItem>
						</Carousel>

						<h4 style="margin-top: 20px;">{{exhibitionInfo.name}}</h4>
						<div style="margin-top: 20px;">开展时间：{{exhibitionInfo.start_time}} - {{exhibitionInfo.end_time}}
						</div>
						<div style="margin-top: 20px;">地址：{{exhibitionInfo.address}}</div>
					</div>
					<div class="col-lg-3">
						<div class="sidebar-wrap sidebar-margin-left">
							<div class="sidebar-widget mb-10">
								<h3 class="sidebar-widget-title">展位信息({{boothTotal}})</h3>
								<div class="sidebar-blog-wrap">
									<div class="single-sidebar-blog" style="cursor: pointer;" v-for="(item,index) in boothList" :key="item.id" @click="toex(item.id)">
										<div class="sidebar-blog-img">
											<img :src="item.image | imgfilter" alt="">
										</div>
										<div class="sidebar-blog-content">
											<span class="category">{{item.areaInfo.name}}</span>
											<h4 class="title">{{item.name}}</h4>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getBoothList,
		getExhibitionInfo
	} from '@/api'
	export default {
		name: 'app',
		data() {
			return {
				bgImg: require('@/static/images/banner/banner-3.jpg'),

				exhibitionInfo: {},
				boothList: [],
				boothTotal: 0
			}
		},
		created() {
			this.getExhibitionInfo()
			this.getBoothList()
		},
		methods: {
			
			toex(id) {
				let routeUrl = this.$router.resolve({
					path: '/exhibtionOther/'+id,
				  })
				  window.open(routeUrl.href, '_blank')
			},

			// 获取会展详情
			async getExhibitionInfo() {
				const res = await getExhibitionInfo({
					id: this.$route.params.id
				})
				this.exhibitionInfo = res.data.exhibitionInfo
			},

			// 获取展位列表
			async getBoothList() {
				const res = await getBoothList({
					id: this.$route.params.id
				})
				let data = res.data
				this.boothTotal = data.count
				this.boothList = data.list
			},
		}
	}
</script>

<style>
</style>
